<template>
  <div class="container">
    <van-form ref="form" v-model="form" :scroll-to-error="true">
      <van-row v-show="showBaseResume">
        <van-col span="24">
          <van-divider>基本信息</van-divider>
          <van-field
            v-model="form.organLabel"
            label="意向门店"
            name="organ"
            readonly
            disabled
            :rules="formRules.organ"
            @click="showOrganList = false"
          />
          <van-popup v-model:show="showOrganList" position="bottom">
            <van-picker
              :columns="organList"
              :columns-field-names="{ text: 'LNAME', value: 'ID' }"
              @confirm="onOrganListConfirm"
              @cancel="showOrganList = false"
            />
          </van-popup>
          <van-field
            v-model="form.departLabel"
            label="意向部门"
            name="depart"
            readonly
            disabled
            :rules="formRules.depart"
            @click="showDepartList = false"
          />
          <van-popup v-model:show="showDepartList" position="bottom">
            <van-picker
              :columns="departList"
              :columns-field-names="{ text: 'LNAME', value: 'ID' }"
              @confirm="onDepartListConfirm"
              @cancel="showDepartList = false"
            />
          </van-popup>
          <van-field
            v-model="form.postLabel"
            label="意向岗位"
            name="post"
            readonly
            disabled
            :rules="formRules.post"
            @click="showPostList = false"
          />
          <van-popup v-model:show="showPostList" position="bottom">
            <van-picker
              :columns="postList"
              :columns-field-names="{ text: 'PNAME', value: 'ID' }"
              @confirm="onPostListConfirm"
              @cancel="showPostList = false"
            />
          </van-popup>
          <van-field
            v-model="form.recruitSourceLabel"
            label="招聘来源"
            name="recruitSource"
            is-link
            readonly
            :rules="formRules.recruitSource"
            placeholder="请选择在何处得知招聘信息"
            @click="showRecruitSourceList = true"
          />
          <van-popup v-model:show="showRecruitSourceList" position="bottom">
            <van-picker
              :columns="recruitSourceList"
              :columns-field-names="{ text: 'DTEXT', value: 'DVALUE' }"
              @confirm="onRecruitSourceConfirm"
              @cancel="showRecruitSourceList = false"
            />
          </van-popup>
          <van-field
            v-model="form.introducer"
            label="推荐人"
            maxlength="5"
            name="introducer"
            placeholder="如有推荐人，可填写其姓名"
          />
          <van-field
            label="有亲朋关系在西亚工作"
            label-width="15em"
            name="personrelation"
            :rules="formRules.personRelation"
          >
            <template #input>
              <van-radio-group
                v-model="form.personRelation"
                direction="horizontal"
                checked-color="#da0b66"
                icon-size="16"
              >
                <van-radio name="1">是</van-radio>
                <van-radio name="0">否</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="attach" label="简历附件" is-link>
            <template v-if="uploadAttach === '0'" #input>
              <van-uploader
                v-model="attach"
                max-count="1"
                :after-read="onUploadFile"
                accept=".xls,.xlsx,.doc,.docx,.pdf"
                :preview-image="false"
              >
                <van-cell
                  value="可上传简历附件以丰富简历内容，非必填"
                  :border="false"
                  style="padding: 0;"
                  class="uploadText"
                />
              </van-uploader>
            </template>
            <template v-else #input>
              <van-cell
                :value="uploadAttach"
                :border="false"
                style="padding: 0;"
                class="uploadText"
                @click="clearUploadAttach()"
              />
            </template>
          </van-field>
          <van-field name="photo" label="照片" :rules="[{ required: true, message: '请上传免冠一寸照片' }]">
            <template #input>
              <van-uploader
                v-model="photo"
                :preview-size="[135, 160]"
                max-count="1"
                file-list="{{ photoFile }}"
                :after-read="onUploadPhoto"
                upload-text="请上传免冠一寸照片"
              />
            </template>
          </van-field>
          <van-field v-model="form.name" label="姓名" maxlength="5" name="name" :rules="formRules.name" />
          <van-field label="性别" name="gender" :rules="formRules.gender">
            <template #input>
              <van-radio-group v-model="form.gender" direction="horizontal" checked-color="#da0b66" icon-size="16">
                <van-radio name="1">男</van-radio>
                <van-radio name="2">女</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            v-model="form.sfid"
            label="身份证"
            name="sfid"
            :formatter="sfidFormatter"
            :rules="formRules.sfid"
            maxlength="18"
          />
          <van-field
            v-show="form.jobtype !== '1'"
            v-model="form.sfiddate"
            label="身份证有效期"
            is-link
            readonly
            name="sfiddate"
            placeholder="请填写身份证有效期限的截止日期"
            :rules="form.jobtype !== '1' ? formRules.sfiddate : formRules.no"
            @click="showSfidDate = true"
          />
          <van-popup v-model:show="showSfidDate" position="bottom">
            <van-datetime-picker
              type="date"
              :min-date="new Date()"
              :max-date="new Date(2099, 12, 31)"
              @confirm="onSfidDateConfirm"
              @cancel="showSfidDate = false"
            />
          </van-popup>
          <van-field v-show="form.jobtype !== '1'" label="婚姻状况" name="married" :rules="formRules.married">
            <template #input>
              <van-radio-group v-model="form.married" direction="horizontal" checked-color="#da0b66" icon-size="16">
                <van-radio name="1">未婚</van-radio>
                <van-radio name="2">已婚</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field label="政治面貌" name="political" :rules="formRules.political">
            <template #input>
              <van-radio-group v-model="form.political" direction="horizontal" checked-color="#da0b66" icon-size="16">
                <van-radio name="1">群众</van-radio>
                <van-radio name="3">团员</van-radio>
                <van-radio name="2">党员</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            v-model="form.nationLabel"
            label="民族"
            is-link
            readonly
            name="nation"
            :rules="formRules.nationLabel"
            @click="showNationList = true"
          />
          <van-popup v-model:show="showNationList" position="bottom">
            <van-picker
              :columns="nationList"
              :columns-field-names="{ text: 'DTEXT', value: 'DVALUE' }"
              @confirm="onNationConfirm"
              @cancel="showNationList = false"
            />
          </van-popup>
          <van-field
            v-model="form.reghouseLabel"
            label="户口所在地"
            name="reghouse"
            is-link
            readonly
            :rules="formRules.reghouse"
            @click="showReghouseList = true"
          />
          <van-popup v-model:show="showReghouseList" position="bottom">
            <van-area :area-list="areaList" @confirm="onReghouseConfirm" @cancel="showReghouseList = false" />
          </van-popup>
          <van-field
            v-show="form.jobtype !== '1'"
            v-model="form.sfidaddr"
            label="身份证住址"
            name="sfidaddr"
            maxlength="20"
            :rules="form.jobtype !== '1' ? formRules.sfidaddr : formRules.no"
          />
          <van-field
            v-model="form.phone"
            label="联系方式"
            type="tel"
            name="phone"
            maxlength="11"
            :rules="formRules.phone"
          />
          <van-field
            v-show="form.jobtype !== '1'"
            v-model="form.interest"
            label="兴趣爱好"
            name="interest"
            maxlength="10"
          />
          <van-field v-model="form.height" label="身高(cm)" name="height" maxlength="3" type="number" placeholder="请填写身高 如:175" :rules="formRules.height" />
          <van-field v-model="form.weight" label="体重(kg)" name="weight" maxlength="3" type="number" placeholder="请填写体重 如:70" :rules="formRules.weight" />
          <van-field v-model="form.email" label="电子邮件" name="email" placeholder="请填写电子邮箱地址" :rules="form.jobtype === '2' ? [] : formRules.email" />
          <van-field v-show="form.jobtype !== '1'" label-width="7em" label="原单位劳动关系" name="workstatus" :rules="formRules.workstatus">
            <template #input>
              <van-radio-group v-model="form.workstatus" direction="horizontal" checked-color="#da0b66" icon-size="16">
                <van-radio name="1">已解除</van-radio>
                <van-radio name="2">未解除</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-divider>教育经历(最高学历)</van-divider>
          <van-field
            v-model="form.educationLabel"
            label="最高学历"
            is-link
            readonly
            name="education"
            :rules="formRules.education"
            @click="showEducationList = true"
          />
          <van-popup v-model:show="showEducationList" position="bottom">
            <van-picker
              :columns="educationList"
              :columns-field-names="{ text: 'DTEXT', value: 'DVALUE' }"
              @confirm="onEducationConfirm"
              @cancel="showEducationList = false"
            />
          </van-popup>
          <van-field
            v-model="form.educschool"
            label="毕业院校"
            name="educschool"
            maxlength="15"
            :rules="formRules.educschool"
          />
          <van-field label="学习方式" name="eductype" :rules="formRules.eductype">
            <template #input>
              <van-radio-group v-model="form.eductype" direction="horizontal" checked-color="#da0b66" icon-size="16">
                <van-radio name="1">全日制统招</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            v-model="form.educstart"
            label="开始时间"
            is-link
            readonly
            name="educstart"
            :rules="formRules.educstart"
            @click="showEducStart = true"
          />
          <van-popup v-model:show="showEducStart" position="bottom">
            <van-datetime-picker
              type="year-month"
              :min-date="form.jobtype === '1' ? new Date(2020, 1, 1) : new Date(1990, 1, 1)"
              @confirm="onEducStartConfirm"
              @cancel="showEducStart = false"
            />
          </van-popup>
          <van-field
            v-model="form.educend"
            label="结束时间"
            is-link
            readonly
            name="educend"
            :rules="formRules.educend"
            @click="showEducEnd = true"
          />
          <van-popup v-model:show="showEducEnd" position="bottom">
            <van-datetime-picker
              type="year-month"
              :min-date="form.jobtype === '1' ? new Date(2020, 1, 1) : new Date(1990, 1, 1)"
              @confirm="onEducEndConfirm"
              @cancel="showEducEnd = false"
            />
          </van-popup>
          <van-field
            v-model="form.spectypeLabel"
            label="专业分类"
            is-link
            readonly
            name="spectype"
            :rules="formRules.spectype"
            @click="showSpecTypeList = true"
          />
          <van-popup v-model:show="showSpecTypeList" position="bottom">
            <van-picker
              :columns="specTypeList"
              :columns-field-names="{ text: 'DTEXT', value: 'DVALUE' }"
              @confirm="onSpecTypeConfirm"
              @cancel="showSpecTypeList = false"
            />
          </van-popup>
          <van-field
            v-model="form.specname"
            label="专业名称"
            name="specname"
            maxlength="10"
            :rules="formRules.specname"
          />
          <van-divider>教育经历(其他学历)非必填</van-divider>
          <van-field
            v-model="form.firstEducationLabel"
            label="其他学历"
            is-link
            readonly
            name="firstEducation"
            @click="showFirstEducationList = true"
          />
          <van-popup v-model:show="showFirstEducationList" position="bottom">
            <van-picker
              :columns="educationList"
              :columns-field-names="{ text: 'DTEXT', value: 'DVALUE' }"
              @confirm="onFirstEducationConfirm"
              @cancel="showFirstEducationList = false"
            />
          </van-popup>
          <van-field v-model="form.firstEducschool" label="毕业院校" name="firstEducschool" maxlength="15" />
          <van-field label="学习方式" name="firstEductype">
            <template #input>
              <van-radio-group
                v-model="form.firstEductype"
                direction="horizontal"
                checked-color="#da0b66"
                icon-size="16"
              >
                <van-radio name="1">统招</van-radio>
                <van-radio name="0">自考</van-radio>
                <van-radio name="2">函授</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            v-model="form.firstEducstart"
            label="开始时间"
            is-link
            readonly
            name="firstEducstart"
            @click="showFirstEducStart = true"
          />
          <van-popup v-model:show="showFirstEducStart" position="bottom">
            <van-datetime-picker
              type="year-month"
              :min-date="form.jobtype === '1' ? new Date(2020, 1, 1) : new Date(1990, 1, 1)"
              @confirm="onFirstEducStartConfirm"
              @cancel="showFirstEducStart = false"
            />
          </van-popup>
          <van-field
            v-model="form.firstEducend"
            label="结束时间"
            is-link
            readonly
            name="firstEducend"
            @click="showFirstEducEnd = true"
          />
          <van-popup v-model:show="showFirstEducEnd" position="bottom">
            <van-datetime-picker
              type="year-month"
              :min-date="form.jobtype === '1' ? new Date(2020, 1, 1) : new Date(1990, 1, 1)"
              @confirm="onFirstEducEndConfirm"
              @cancel="showFirstEducEnd = false"
            />
          </van-popup>
          <van-field
            v-model="form.firstSpectypeLabel"
            label="专业分类"
            is-link
            readonly
            name="firstSpectype"
            @click="showFirstSpecTypeList = true"
          />
          <van-popup v-model:show="showFirstSpecTypeList" position="bottom">
            <van-picker
              :columns="specTypeList"
              :columns-field-names="{ text: 'DTEXT', value: 'DVALUE' }"
              @confirm="onFirstSpecTypeConfirm"
              @cancel="showFirstSpecTypeList = false"
            />
          </van-popup>
          <van-field v-model="form.firstSpecname" label="专业名称" name="firstSpecname" maxlength="10" />
          <van-field label="曾任学生干部" name="isScadre" :rules="formRules.isScadre">
            <template #input>
              <van-radio-group v-model="form.isScadre" direction="horizontal" checked-color="#da0b66" icon-size="16">
                <van-radio name="1">是</van-radio>
                <van-radio name="0">否</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            v-show="form.isScadre === '1'"
            v-model="form.scadrePost"
            label="学生干部职位"
            placeholder="如：班长、团支书"
            name="scadrePost"
            maxlength="10"
            :rules="form.isScadre === '1' ? formRules.scadrePost : []"
          />
          <div style="margin: 16px">
            <van-space direction="vertical" fill>
              <van-button
                v-if="form.jobtype !== '1'"
                block
                :loading="buttonLoading"
                color="#da0b66"
                loading-type="spinner"
                type="primary"
                size="small"
                @click="toNextStep"
              >
                下一步 (填写工作经历)
              </van-button>
              <van-button
                v-else
                block
                color="#da0b66"
                type="primary"
                size="small"
                @click="onSubmit"
              >
                提交简历
              </van-button>
              <van-radio-group v-model="discChecked">
                <van-radio name="1" icon-size="16px" checked-color="#da0b66" @click="showDisc = true">
                  <span style="text-decoration: underline">本人已阅读并同意《个人信息保护声明》</span>
                </van-radio>
              </van-radio-group>
            </van-space>
          </div>
        </van-col>
      </van-row>
      <div v-show="showOtherFill">
        <!--工作经历块-->
        <van-divider :style="{ color: '#da0b66', borderColor: '#da0b66'}">工作经历(最少填写最近1个工作经历最多3个)
        </van-divider>
        <van-cell-group inset class="workHis">
          <van-cell v-for="item in workHisList" :key="item.id" center border title-style="text-align:left">
            <template #title>
              <div style="width: 20em">{{ item.unit }}</div>
              <van-tag color="#d2065c">{{ item.work }}</van-tag>
            </template>
            <template #value>
              <van-space>
                <van-icon name="edit" size="20" @click="onEditWorkHis(item)" />
                <van-icon name="delete" size="20" @click="onDeleteWorkHis(item)" />
              </van-space>
            </template>
            <template #label>
              {{ item.workstart }} 至 {{ item.workend }}
            </template>
          </van-cell>
        </van-cell-group>
        <van-button
          v-show="workHisList.length < 3"
          style="margin-top: 16px"
          round
          icon="plus"
          type="primary"
          color="#da0b66"
          size="small"
          @click="onAddWorkHis"
        >添加工作经历
        </van-button>
        <!--西亚工作经历块-->
        <van-divider :style="{ color: '#da0b66', borderColor: '#da0b66',marginTop:'10%'}">西亚工作经历(如曾在西亚工作请填写)
        </van-divider>
        <van-cell-group inset>
          <van-cell v-for="item in xyWorkHisList" :key="item.id" center border title-style="text-align:left">
            <template #title>
              <div style="width: 20em">{{ item.organ + item.depart }}</div>
              <van-tag color="#d2065c">{{ item.post }}</van-tag>
            </template>
            <template #value>
              <van-space>
                <van-icon name="edit" size="20" @click="onEditXyWorkHis(item)" />
                <van-icon name="delete" size="20" @click="onDeleteXyWorkHis(item)" />
              </van-space>
            </template>
            <template #label>
              {{ item.xyworkstart }} 至 {{ item.xyworkend }}
            </template>
          </van-cell>
        </van-cell-group>
        <van-button
          v-show="xyWorkHisList.length < 1"
          style="margin-top: 16px"
          round
          icon="plus"
          type="primary"
          color="#da0b66"
          size="small"
          @click="onAddXyWorkHis"
        >添加西亚工作经历
        </van-button>
        <!--家庭成员/紧急联系人块-->
        <van-divider :style="{ color: '#da0b66', borderColor: '#da0b66',marginTop:'10%'}">家庭成员/紧急联系人(最少填写2位紧急联系人最多3个)
        </van-divider>
        <van-cell-group inset>
          <van-cell v-for="item in familyContactList" :key="item.id" center border title-style="text-align:left">
            <template #title>
              <div style="width: 20em;">{{ item.name }}
                <van-tag style="margin-left: 10px;" color="#d2065c">{{
                  item.relation
                }}
                </van-tag>
              </div>
            </template>
            <template #value>
              <van-space>
                <van-icon name="edit" size="20" @click="onEditFamilyContact(item)" />
                <van-icon name="delete" size="20" @click="onDeleteFamilyContact(item)" />
              </van-space>
            </template>
            <template #label>
              {{ item.tel }}
            </template>
          </van-cell>
        </van-cell-group>
        <van-button
          v-show="familyContactList.length < 3"
          style="margin-top: 16px"
          round
          icon="plus"
          type="primary"
          color="#da0b66"
          size="small"
          @click="onAddFamilyContact"
        >添加家庭成员/紧急联系人
        </van-button>
        <div style="margin: 16px">
          <van-space direction="vertical" fill>
            <van-button block type="primary" color="#da0b66" size="small" @click="toPrevStep">
              上一步
            </van-button>
            <van-button
              block
              color="#da0b66"
              type="primary"
              size="small"
              @click="onSubmit"
            >
              提交简历
            </van-button>
            <van-radio-group v-model="discChecked">
              <van-radio name="1" icon-size="16px" checked-color="#da0b66" @click="showDisc = true">
                <span style="text-decoration: underline">本人已阅读并同意《个人信息保护声明》</span>
              </van-radio>
            </van-radio-group>
          </van-space>
        </div>
      </div>
    </van-form>

    <!-- 工作经历添加 -->
    <van-dialog
      v-model:show="showAddWorkHis"
      width="90%"
      :show-cancel-button="true"
      :before-close="onAddWorkHisBeforeClose"
      confirm-button-text="添加"
    >
      <AddWorkHis ref="addWorkHis" />
    </van-dialog>
    <!-- 工作经历编辑 -->
    <van-dialog
      v-model:show="showEditWorkHis"
      width="90%"
      :show-cancel-button="true"
      :before-close="onEditWorkHisBeforeClose"
      confirm-button-text="保存"
    >
      <EditWorkHis ref="editWorkHis" :work-his-data="workHisData" />
    </van-dialog>
    <!--西亚工作经历添加-->
    <van-dialog
      v-model:show="showAddXyWorkHis"
      width="90%"
      :show-cancel-button="true"
      :before-close="onAddXyWorkHisBeforeClose"
      confirm-button-text="添加"
    >
      <AddXyWorkHis ref="addXyWorkHis" />
    </van-dialog>
    <!-- 西亚工作经历编辑 -->
    <van-dialog
      v-model:show="showEditXyWorkHis"
      width="90%"
      :show-cancel-button="true"
      :before-close="onEditXyWorkHisBeforeClose"
      confirm-button-text="保存"
    >
      <EditXyWorkHis ref="editXyWorkHis" :xy-work-his-data="xyWorkHisData" />
    </van-dialog>
    <!--家庭成员紧急联系人添加-->
    <van-dialog
      v-model:show="showAddFamilyContact"
      width="90%"
      :show-cancel-button="true"
      :before-close="onAddFamilyContactBeforeClose"
      confirm-button-text="添加"
    >
      <AddFamilyContact ref="addFamilyContact" />
    </van-dialog>
    <!-- 家庭成员紧急联系人编辑 -->
    <van-dialog
      v-model:show="showEditFamilyContact"
      width="90%"
      :show-cancel-button="true"
      :before-close="onEditFamilyContactBeforeClose"
      confirm-button-text="保存"
    >
      <EditFamilyContact ref="editFamilyContact" :family-contact-data="familyContactData" />
    </van-dialog>
    <!-- 填写说明 -->
    <van-dialog v-model:show="showDesc" width="90%" style="top: 50%;margin-top: 10px;">
      <template #footer>
        <van-button text="本人已阅读并同意" style="color:#da0b66" block @click="onDescBeforeClose" />
      </template>
      <Description />
    </van-dialog>
    <!-- 信息保护声明 -->
    <van-dialog v-model:show="showDisc" width="90%" style="top: 50%;margin-top: 10px;">
      <template #footer>
        <van-button
          :disabled="!confirmButton"
          text="本人已阅读并同意"
          style="color:#da0b66"
          block
          @click="onDiscBeforeClose"
        >
          <template #icon>
            <van-count-down
              v-if="!confirmButton"
              ref="count"
              style="color:#da0b66"
              :time="10000"
              :auto-start="true"
              format="ss"
              @finish="confirmButton = true"
            />
          </template>
        </van-button>
      </template>
      <Disclaimers />
    </van-dialog>
  </div>
</template>
<script>
import EditWorkHis from '@/views/Resume/EditWorkHis.vue'
import AddWorkHis from '@/views/Resume/AddWorkHis.vue'
import Disclaimers from '@/views/Disclaimers.vue'
import Description from '@/views/Description.vue'
import AddXyWorkHis from '@/views/Resume/AddXyWorkHis'
import EditXyWorkHis from '@/views/Resume/EditXyWorkHis'
import AddFamilyContact from '@/views/Resume/AddFamilyContact'
import EditFamilyContact from '@/views/Resume/EditFamilyContact'
import formRules from '@/comm/rules.js'
import { dateFormat, monthFormat } from '@/comm/comm.js'
import { getCurrentInstance } from 'vue'
import {
  postResume,
  getDictData,
  changeDepart,
  changePost,
  uploadPhoto,
  uploadFile
} from '@/api/api.js'

export default {
  components: {
    EditWorkHis,
    AddWorkHis,
    Disclaimers,
    Description,
    AddXyWorkHis,
    EditXyWorkHis,
    AddFamilyContact,
    EditFamilyContact
  },
  beforeRouteLeave() {
    clearInterval(this.saveInterval)
  },
  setup() {
    const sfidFormatter = (value) => value.toUpperCase()
    const saveInterval = function() {
    }
    return {
      sfidFormatter,
      formRules,
      saveInterval
    }
  },
  data() {
    return {
      showDesc: false,
      showBaseResume: true,
      showOtherFill: false,
      showEditWorkHis: false,
      showAddWorkHis: false,
      showEditXyWorkHis: false,
      showAddXyWorkHis: false,
      showEditFamilyContact: false,
      showAddFamilyContact: false,
      showDisc: false,
      buttonLoading: false,
      discChecked: '0',
      confirmButton: false,
      workHisList: [],
      xyWorkHisList: [],
      familyContactList: [],
      workHisData: {},
      xyWorkHisData: {},
      familyContactData: {},
      photo: [],
      attach: [],
      uploadAttach: '0',
      // form: {
      //   post: "",
      //   postLabel: "",
      //   organ: "",
      //   organLabel: "",
      //   depart: "",
      //   departLabel: "",
      //   name: "李亚楠",
      //   sfiddate: "2040-01-22",
      //   nation: "02",
      //   nationLabel: "蒙古族",
      //   political: "1",
      //   education: "3",
      //   educationLabel: "高中",
      //   gender: "1",
      //   married: "1",
      //   educstart: "2022-01",
      //   educend: "2022-01",
      //   educschool: "北京大学",
      //   eductype: "1",
      //   specname: "计算机应用",
      //   spectype: "4",
      //   spectypeLabel: "计算机",
      //   phone: "13949151731",
      //   reghouse: "",
      //   reghouseLabel: "",
      //   sfid: "411502199201010546",
      //   interest: "游泳",
      //   homeaddr: "浉河住宅小区",
      //   workstatus: "1",
      //   workHis: [],
      //   personRelation: "",
      //   readDesc: "0",
      //   firstEducationLabel:"",
      //   firstEducstart: "",
      //   firstEducend: "",
      //   firstEducschool: "",
      //   firstEductype: "",
      //   firstSpecname: "",
      //   firstSpectype: "",
      //   firstSpectypeLabel: "",
      //   introducer: ""
      // },
      form: {
        personRelation: '',
        readDesc: '0',
        post: '',
        postLabel: '',
        name: '',
        introducer: '',
        sfiddate: '',
        nation: '',
        nationLabel: '',
        recruitSourceLabel: '',
        recruitSource: '',
        political: '',
        gender: '',
        married: '',
        education: '',
        educationLabel: '',
        educstart: '',
        educend: '',
        educschool: '',
        eductype: '1',
        specname: '',
        spectype: '',
        spectypeLabel: '',
        firstEducation: '',
        firstEducationLabel: '',
        firstEducstart: '',
        firstEducend: '',
        firstEducschool: '',
        firstEductype: '',
        firstSpecname: '',
        firstSpectype: '',
        firstSpectypeLabel: '',
        isScadre: '',
        scadrePost: '',
        phone: '',
        reghouse: '',
        sfid: '',
        interest: '',
        homeaddr: '',
        workstatus: '',
        openid: '',
        attach: '',
        height: '',
        weight: '',
        email: '',
        jobtype: ''
      },
      showSfidDate: false,
      showNationList: false,
      showEducationList: false,
      showRecruitSourceList: false,
      showEducStart: false,
      showEducEnd: false,
      showSpecTypeList: false,
      showPostList: false,
      showReghouseList: false,
      showOrganList: false,
      showDepartList: false,
      fillFinish: false,
      showFirstEducationList: false,
      showFirstEducStart: false,
      showFirstEducEnd: false,
      showFirstSpecTypeList: false,
      nationList: [],
      recruitSourceList: [],
      educationList: [],
      specTypeList: [],
      postList: [],
      organList: [],
      departList: [],
      areaList: {
        province_list: {},
        city_list: {},
        county_list: {}
      },
      photoFile: []
    }
  },
  async created() {
    const temporarySaveData = JSON.parse(localStorage.getItem('temporaryData'))
    if (temporarySaveData != null) {
      this.form = temporarySaveData
      this.workHisList = temporarySaveData.workHis ? temporarySaveData.workHis : []
      this.xyWorkHisList = temporarySaveData.xyWorkHis ? temporarySaveData.xyWorkHis : []
      this.familyContactList = temporarySaveData.familyContact ? temporarySaveData.familyContact : []
    }
    this.temporaryData()
    const { appContext } = getCurrentInstance()
    appContext.config.globalProperties.userSession()
    await this.getDictData().then(() => {
      this.organList.forEach((item) => {
        if (item.ID === this.$route.query.organ) {
          this.form.organ = this.$route.query.organ
          this.form.organLabel = item.LNAME
        }
      })
      this.departList.forEach((item) => {
        if (item.ID === this.$route.query.depart) {
          this.form.depart = this.$route.query.depart
          this.form.departLabel = item.LNAME
        }
      })
      this.postList.forEach((item) => {
        if (item.ID === this.$route.query.post) {
          this.form.post = this.$route.query.post
          this.form.postLabel = item.PNAME
        }
      })
    })
    this.form.jobtype = this.$route.query.jobtype
    this.showDesc = true
  },
  methods: {
    temporaryData() {
      this.saveInterval = setInterval(() => {
        if (this.workHisList.length > 0) {
          this.form.workHis = this.workHisList
        }
        if (this.xyWorkHisList.length > 0) {
          this.form.xyWorkHis = this.xyWorkHisList
        }
        if (this.familyContactList.length > 0) {
          this.form.familyContact = this.familyContactList
        }
        localStorage.setItem('temporaryData', JSON.stringify(this.form))
      }, 10000)
      this.saveInterval
    },
    async getDictData() {
      await getDictData().then((response) => {
        const res = response.data
        if (res.code === 200) {
          this.nationList = res.data.nation
          this.postList = res.data.post
          this.organList = res.data.organ
          this.departList = res.data.depart
          this.areaList.province_list = res.data.sheng
          this.areaList.city_list = res.data.shi
          this.areaList.county_list = res.data.qu
          this.recruitSourceList = res.data.recruitSource
          this.educationList = res.data.education
          this.specTypeList = res.data.spectype
        }
      })
    },
    onNationConfirm(res) {
      this.showNationList = false
      this.form.nationLabel = res.DTEXT
      this.form.nation = res.DVALUE
    },
    onRecruitSourceConfirm(res) {
      this.showRecruitSourceList = false
      this.form.recruitSourceLabel = res.DTEXT
      this.form.recruitSource = res.DVALUE
    },
    onEducationConfirm(res) {
      this.showEducationList = false
      this.form.educationLabel = res.DTEXT
      this.form.education = res.DVALUE
    },
    onFirstEducationConfirm(res) {
      this.showFirstEducationList = false
      this.form.firstEducationLabel = res.DTEXT
      this.form.firstEducation = res.DVALUE
    },
    onSfidDateConfirm(res) {
      this.showSfidDate = false
      this.form.sfiddate = dateFormat(res)
    },
    onEducStartConfirm(res) {
      this.showEducStart = false
      if (this.form.jobtype === '1') {
        const nowdata = res == null ? new Date() : new Date(res)
        this.form.educstart = nowdata.getFullYear() + '/09'
      } else {
        this.form.educstart = monthFormat(res)
      }
    },
    onEducEndConfirm(res) {
      this.showEducEnd = false
      if (this.form.jobtype === '1') {
        const nowdata = res == null ? new Date() : new Date(res)
        this.form.educend = nowdata.getFullYear() + '/06'
      } else {
        this.form.educend = monthFormat(res)
      }
    },
    onSpecTypeConfirm(res) {
      this.showSpecTypeList = false
      this.form.spectypeLabel = res.DTEXT
      this.form.spectype = res.DVALUE
    },
    onFirstEducStartConfirm(res) {
      this.showFirstEducStart = false
      this.form.firstEducstart = monthFormat(res)
    },
    onFirstEducEndConfirm(res) {
      this.showFirstEducEnd = false
      this.form.firstEducend = monthFormat(res)
    },
    onFirstSpecTypeConfirm(res) {
      this.showFirstSpecTypeList = false
      this.form.firstSpectypeLabel = res.DTEXT
      this.form.firstSpectype = res.DVALUE
    },
    onPostListConfirm(res) {
      this.showPostList = false
      this.form.postLabel = res.PNAME
      this.form.post = res.ID
    },
    onOrganListConfirm(res) {
      this.showOrganList = false
      this.form.organLabel = res.LNAME
      this.form.organ = res.ID
      changeDepart({ organ: res.ID }).then((response) => {
        const res = response.data
        if (res.code === 200) {
          this.departList = []
          this.departList = res.data
          this.form.depart = ''
          this.form.departLabel = ''
          this.form.post = ''
          this.form.postLabel = ''
        }
      })
    },
    onDepartListConfirm(res) {
      this.showDepartList = false
      this.form.departLabel = res.LNAME
      this.form.depart = res.ID
      changePost({ depart: res.ID }).then((response) => {
        const res = response.data
        if (res.code === 200) {
          this.postList = []
          this.postList = res.data
          this.form.post = ''
          this.form.postLabel = ''
        }
      })
    },
    onReghouseConfirm(res) {
      this.showReghouseList = false
      this.form.reghouseLabel = res
        .filter((item) => !!item)
        .map((item) => item.name)
        .join('/')
      this.form.reghouse = res[2]['code']
    },
    onUploadPhoto(file) {
      const content = file.file
      const formData = new FormData()
      formData.append('photo', content, 'uploadPhoto')
      uploadPhoto(formData).then((response) => {
        const res = response.data
        this.$toast(res.msg)
        if (res.code === 200) {
          this.form.photo = res.data
        }
      })
    },
    onUploadFile(file) {
      const content = file.file
      const formData = new FormData()
      formData.append('attach', content, 'uploadFile')
      uploadFile(formData).then((response) => {
        const res = response.data
        this.$toast(res.msg)
        if (res.code === 200) {
          this.form.attach = res.data
          this.uploadAttach = content.name
        }
      })
    },
    clearUploadAttach() {
      this.uploadAttach = '0'
      this.attach = []
    },
    async onSubmit() {
      const flagA = this.workHisList.length > 0 || this.form.jobtype === '1'
      const flagB = this.familyContactList.length >= 2 || this.form.jobtype === '1'
      const flagC = this.discChecked === '1'
      if (flagA && flagB && flagC) {
        const toast = this.$toast.loading({ message: '正在提交' })
        if (this.form.jobtype === '1') {
          this.form.married = '1'
          this.form.workstatus = '1'
        }
        await Promise.all([this.$refs.form.validate()])
          .then(result => {
            if (result) {
              this.fillFinish = true
              console.log(result)
            }
          })
          .catch((error) => {
            console.log(error)
            this.$toast(error[0].message)
          })
        if (this.workHisList.length > 0) {
          this.form.workHis = this.workHisList
        }
        if (this.xyWorkHisList.length > 0) {
          this.form.xyWorkHis = this.xyWorkHisList
        }
        if (this.familyContactList.length > 0) {
          this.form.familyContact = this.familyContactList
        }
        if (this.fillFinish && (this.workHisList.length > 0 || this.form.jobtype === '1')) {
          setTimeout(() => {
            this.form.openid = sessionStorage.getItem('openid')
            if (this.form.jobtype === '' || this.form.jobtype === null) {
              this.form.jobtype = sessionStorage.getItem('jobtype')
            }
            postResume({ resume: this.form }).then((response) => {
              const res = response.data
              if (res.code === 200) {
                this.$dialog.alert({
                  message: res.msg
                }).then(() => {
                  localStorage.removeItem('temporaryData')
                  this.$router.push({ path: '/' })
                })
              } else {
                this.$dialog.alert({
                  message: res.msg
                })
              }
            })
            toast.clear()
          }, 500)
        }
      } else {
        if (!flagA) {
          this.$dialog.alert({
            message: '请添加至少一个工作经历'
          })
        } else if (!flagB) {
          this.$dialog.alert({
            message: '请添加至少两个家庭成员/紧急联系人'
          })
        } else if (!flagC) {
          this.$dialog.alert({
            message: '请确认您已阅读并同意个人信息保护声明'
          })
        }
      }
    },
    toNextStep() {
      this.buttonLoading = true
      this.fillFinish = true
      setTimeout(() => {
        Promise.all([this.$refs.form.validate()])
          .then((result) => {
            if (result) {
              this.showBaseResume = false
              this.showOtherFill = true
            }
          })
          .catch((error) => {
            console.log(error)
            this.$toast(error[0].message)
          })
        this.buttonLoading = false
      }, 500)
    },
    toPrevStep() {
      this.showBaseResume = true
      this.showOtherFill = false
    },
    onAddWorkHis() {
      if (this.workHisList.length >= 3) {
        this.$toast('最多只可以填写3段工作经历')
        return
      }
      this.showAddWorkHis = true
    },
    onEditWorkHis(item) {
      this.workHisData = JSON.parse(JSON.stringify(item))
      this.showEditWorkHis = true
    },
    onDeleteWorkHis(item) {
      for (let i = 0; i < this.workHisList.length; i++) {
        if (this.workHisList[i].id === item.id) {
          this.workHisList.splice(i, 1)
        }
      }
    },
    onAddWorkHisBeforeClose(action) {
      if (action === 'cancel') {
        this.$refs.addWorkHis.onReset()
        this.$refs.addWorkHis.form = {}
        return true
      } else {
        Promise.all([this.$refs.addWorkHis.validateForm()]).then(() => {
          this.$refs.addWorkHis.form.id = this.workHisList.length
          this.workHisList.push(this.$refs.addWorkHis.form)
          this.$refs.addWorkHis.onReset()
          this.$refs.addWorkHis.form = {}
          this.showAddWorkHis = false
        })
      }
    },
    onEditWorkHisBeforeClose(action) {
      if (action === 'cancel') {
        this.$refs.editWorkHis.onReset()
        return true
      } else {
        Promise.all([this.$refs.editWorkHis.validateForm()]).then(() => {
          for (let i = 0; i < this.workHisList.length; i++) {
            if (this.workHisList[i].id === this.$refs.editWorkHis.form.id) {
              this.workHisList[i] = this.$refs.editWorkHis.form
            }
          }
          this.$refs.editWorkHis.onReset()
          this.$refs.editWorkHis.form = {}
          this.showEditWorkHis = false
        })
      }
    },
    onAddXyWorkHis() {
      if (this.xyWorkHisList.length >= 1) {
        this.$toast('最多只可以填写1段西亚工作经历')
        return
      }
      this.showAddXyWorkHis = true
    },
    onEditXyWorkHis(item) {
      this.xyWorkHisData = JSON.parse(JSON.stringify(item))
      this.showEditXyWorkHis = true
    },
    onDeleteXyWorkHis(item) {
      for (let i = 0; i < this.xyWorkHisList.length; i++) {
        if (this.xyWorkHisList[i].id === item.id) {
          this.xyWorkHisList.splice(i, 1)
        }
      }
    },
    onAddXyWorkHisBeforeClose(action) {
      if (action === 'cancel') {
        this.$refs.addXyWorkHis.onReset()
        this.$refs.addXyWorkHis.form = {}
        return true
      } else {
        Promise.all([this.$refs.addXyWorkHis.validateForm()]).then(() => {
          this.$refs.addXyWorkHis.form.id = this.xyWorkHisList.length
          this.xyWorkHisList.push(this.$refs.addXyWorkHis.form)
          this.$refs.addXyWorkHis.onReset()
          this.$refs.addXyWorkHis.form = {}
          this.showAddXyWorkHis = false
        })
      }
    },
    onEditXyWorkHisBeforeClose(action) {
      if (action === 'cancel') {
        this.$refs.editXyWorkHis.onReset()
        return true
      } else {
        Promise.all([this.$refs.editXyWorkHis.validateForm()]).then(() => {
          for (let i = 0; i < this.xyWorkHisList.length; i++) {
            if (this.xyWorkHisList[i].id === this.$refs.editXyWorkHis.form.id) {
              this.xyWorkHisList[i] = this.$refs.editXyWorkHis.form
            }
          }
          this.$refs.editXyWorkHis.onReset()
          this.$refs.editXyWorkHis.form = {}
          this.showEditXyWorkHis = false
        })
      }
    },
    onAddFamilyContact() {
      if (this.familyContactList.length >= 3) {
        this.$toast('最多只可以填写3位家庭成员紧急联系人')
        return
      }
      this.showAddFamilyContact = true
    },
    onEditFamilyContact(item) {
      this.familyContactData = JSON.parse(JSON.stringify(item))
      this.showEditFamilyContact = true
    },
    onDeleteFamilyContact(item) {
      for (let i = 0; i < this.familyContactList.length; i++) {
        if (this.familyContactList[i].id === item.id) {
          this.familyContactList.splice(i, 1)
        }
      }
    },
    onAddFamilyContactBeforeClose(action) {
      if (action === 'cancel') {
        this.$refs.addFamilyContact.onReset()
        this.$refs.addFamilyContact.form = {}
        return true
      } else {
        let flag = false
        this.familyContactList.filter(item => {
          if (item.tel === this.$refs.addFamilyContact.form.tel) {
            flag = true
          }
        })
        if (flag) {
          this.$toast('不能添加同样的手机号码')
          return false
        }
        Promise.all([this.$refs.addFamilyContact.validateForm()]).then(() => {
          this.$refs.addFamilyContact.form.id = this.familyContactList.length
          this.familyContactList.push(this.$refs.addFamilyContact.form)
          this.$refs.addFamilyContact.onReset()
          this.$refs.addFamilyContact.form = {}
          this.showAddFamilyContact = false
        })
      }
    },
    onEditFamilyContactBeforeClose(action) {
      if (action === 'cancel') {
        this.$refs.editFamilyContact.onReset()
        return true
      } else {
        let flag = false
        this.familyContactList.filter(item => {
          if (item.tel === this.$refs.editFamilyContact.form.tel && item.id !== this.$refs.editFamilyContact.form.id) {
            flag = true
          }
        })
        if (flag) {
          this.$toast('不能添加同样的手机号码')
          return false
        }
        Promise.all([this.$refs.editFamilyContact.validateForm()]).then(() => {
          for (let i = 0; i < this.familyContactList.length; i++) {
            if (this.familyContactList[i].id === this.$refs.editFamilyContact.form.id) {
              this.familyContactList[i] = this.$refs.editFamilyContact.form
            }
          }
          this.$refs.editFamilyContact.onReset()
          this.$refs.editFamilyContact.form = {}
          this.showEditFamilyContact = false
        })
      }
    },
    onDiscBeforeClose() {
      this.showDisc = false
    },
    onDescBeforeClose() {
      this.form.readDesc = '1'
      this.showDesc = false
    }
  }
}
</script>
<style scoped>
::v-deep .uploadText .van-cell__value span {
  color: #c7c7c7;
}
</style>
